<template>
  <div class="pt-3">
    <div v-if="!loading">
      <v-card
        class="pa-3 rounded-lg mb-3"
        flat
        v-if="dataSet && dataSet.attachment"
      >
        <v-row>
          <v-col cols="12" md="2">
            <b>Status</b>
            <div>
              <v-btn
                :color="
                  dataSet.approval == 'approved'
                    ? '#006341'
                    : dataSet.approval == 'declined'
                    ? 'red'
                    : dataSet.approval == 'revision'
                    ? 'orange'
                    : '#757575'
                "
                dark
                rounded
                depressed
                class="text-capitalize"
                small
              >
                {{ dataSet.approval }}
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <b>Date updated</b>
            <div>
              <v-icon>mdi-calendar</v-icon>
              {{ $date(dataSet.updated_at).format("DD, MMMM, YYYY HH:mm") }}
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <b>Notes</b>
            <p class="ma-0">
              {{ dataSet.notes ? dataSet.notes : "-" }}
            </p>
          </v-col>
          <v-col cols="12" md="3">
            <b>Link</b>
            <p class="ma-0">
              <a v-if="dataSet.attachment" :href="dataSet.attachment" class="no_decoration" target="_blank">
                {{ dataSet.attachment ? dataSet.attachment : "-" }}
              </a>
              {{ dataSet.attachment ? '' : '-' }}
            </p>
          </v-col>
        </v-row>
      </v-card>
      <div>
        <!-- v-if="
            (dataSet.approval == 'process' && !dataSet.attachment) ||
            dataSet.approval == 'revision' ||
            dataSet.approval == 'declined'
          " -->
        <!-- <v-card class="rounded-lg mb-3" flat>
          <div class="bg_default px-5 py-3">
            <h3 class="white--text">Upload Your Contract</h3>
          </div>
          <div class="d-flex align-start pa-3">
            <v-icon class="mr-2 mt-1">mdi-tray-arrow-up</v-icon>
            <div>
              <div class="d-flex align-center">
                <h3>Upload file</h3>
                <p class="default_txt ml-2">
                  (Max 1mb, File types allowed are PDF)
                </p>
              </div>
              <v-card
                class="mt-3 temp_input rounded-lg d-flex justify-center align-center"
                @click="$refs.file.click()"
                v-if="!file"
                flat
              >
                <div>
                  <v-icon>mdi-file</v-icon>
                  <b class="default_txt"> <u>Upload your file</u> </b>
                </div>

                <input
                  type="file"
                  ref="file"
                  @change="chooseFile($event)"
                  accept="application/pdf"
                  class="input_hide"
                />
              </v-card>
              <v-card
                class="mt-3 pa-3 temp_input rounded-lg d-flex justify-center align-center"
                @click="$refs.file.click()"
                v-if="file"
                flat
              >
                <div>
                  <div class="d-flex align-start">
                    <v-icon color="var(--g)">mdi-file</v-icon>
                    <p class="ma-0 color_default" v-snip="2">
                      <b> {{ file[0].name }} </b>
                    </p>
                  </div>
                  <v-btn
                    class="rounded-lg mt-3 text-capitalize"
                    dark
                    width="150px"
                    color="var(--g)"
                    depressed
                    @click="file = null"
                    >Change file</v-btn
                  >
                </div>
              </v-card>

              <v-btn
                @click="uploadContract"
                class="rounded-lg mt-3"
                dark
                width="150px"
                depressed
                color="var(--g)"
                >Send</v-btn
              >
            </div>
          </div>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="sending"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="#006341"
            ></v-progress-circular>
            <b class="color_default">Loading...</b>
          </v-overlay>
        </v-card> -->
      </div>
    </div>
    <!-- <div
      v-if="!dataSet && !loading"
      class="d-flex align-center justify-center flex-column"
    >
      <img
        src="../../../../assets/img/gundam/LMS Aset Illustrasi No Section.png"
        height="200px"
        alt=""
      />
      <b class="default_txt my-3"
        >There is no contract to upload. Please wait for administrator to sent
        you the contract</b
      >
    </div> -->
    <div v-if="loading">
      <loading-lg />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "uploadContract",
  computed: {
    ...mapState({
      id: (state) => state.id,
    }),
  },
  data() {
    return {
      loading: false,
      sending: false,
      file: null,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
    };
  },
  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/contract/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    chooseFile(e) {
      this.file = e.target.files;
    },
    uploadContract() {
      this.sending = true;
      let body = new FormData();
      body.append("attachment", this.file[0]);
      // let body = {
      //   attachment: this.file[0],
      // };
      let data = {
        path: `scholar/contract/upload`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.file = null;
          this.fetchData();
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.sending = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: center;
}
.input_hide {
  display: none;
}
.temp_input {
  width: 300px;
  height: 150px;
  border: 1px var(--g) dashed;
}
</style>
